import axios from 'axios';

export const musicApi = {
  /**
   * 스페이스 현재 재생 음원 조회
   */
  getCurrentPlayingMusic(spaceId) {
    return axios.post('/api/space/selectSpaceCurrentPlayMusic', { spaceId });
  },
};
